import React from "react";
import StatusBadge from "../components/common/StatusBadge";

const SettingsPage: React.FC = () => {
	return (
		<div className="space-y-4">
			<div className="flex items-center justify-between">
				<div>
					<h1 className="text-xl font-semibold text-ink">Settings</h1>
					<p className="text-sm text-muted">
						デフォルト手数料 / 販売期間 / Feature Flag
					</p>
				</div>
				<StatusBadge label="P1: caution sets" tone="blue" />
			</div>

			<div className="rounded-2xl border border-surface-border bg-white p-4 shadow-card space-y-4">
				<div>
					<h2 className="text-lg font-semibold text-ink">手数料デフォルト</h2>
					<p className="text-xs text-muted">
						backend config('features.services') と揃える
					</p>
					<div className="mt-2 grid gap-3 md:grid-cols-3">
						<label className="form-field">
							<span>platform_fee_rate</span>
							<input className="input" type="number" defaultValue={8} />
						</label>
						<label className="form-field">
							<span>payment_fee_rate</span>
							<input className="input" type="number" defaultValue={3.6} />
						</label>
						<label className="form-field">
							<span>販売デフォルト期間 (日)</span>
							<input className="input" type="number" defaultValue={30} />
						</label>
					</div>
				</div>

				<div className="pt-2">
					<h2 className="text-lg font-semibold text-ink">Feature Flags</h2>
					<div className="mt-2 grid gap-3 md:grid-cols-3">
						{["ticketing", "studio_rental", "edu_content"].map((service) => (
							<label
								key={service}
								className="flex items-center justify-between rounded-xl border border-surface-border bg-surface-alt px-3 py-2 text-sm font-semibold text-ink"
							>
								<span>{service}</span>
								<input
									type="checkbox"
									defaultChecked={service === "ticketing"}
								/>
							</label>
						))}
					</div>
				</div>

				<div className="flex justify-end">
					<button className="rounded-xl bg-primary px-3 sm:px-4 py-2 text-sm font-semibold text-white">
						保存 (モック)
					</button>
				</div>
			</div>
		</div>
	);
};

export default SettingsPage;
